
<button class="button-base button-primary" type="button" title="Spaltenauswahl anzeigen" (click)="showColumnSelection = !showColumnSelection">Spaltenauswahl</button>
@if (showColumnSelection) {
  <div class="absolute z-10 right-3">
    <div class="shadow-lg ring-1 ring-black ring-opacity-5 overflow-hidden bg-white">
      <div class="relative grid gap-1 bg-white px-1 py-2">
        <h3 class="p-1">Verfügbare Spalten</h3>
        <hr class="my-2">
        @for (col of columnSettings; track col) {
          <div class="flex items-start p-1 transition ease-in-out duration-150 hover:bg-gray-50">
            <pim-checkbox [checked]="col.enabled" [label]="col.name" (checkboxChanged)="updateColumnSettings(col)"></pim-checkbox>
          </div>
        }
      </div>
    </div>
  </div>
}